/** Register desktop deep-link handlers for cloud magic-link callbacks. */

import { parseAuthCallbackUrl } from "./cloudAuth";
import { isTauri } from "./runtime";

export const CLOUD_AUTH_EVENT = "zw:cloud-auth";

export function notifyCloudAuth(): void {
  window.dispatchEvent(new CustomEvent(CLOUD_AUTH_EVENT));
}

/**
 * Listen for `zephyrwrite://auth/callback?...` and persist the session.
 * Call once from the root app so auth works even when Settings is closed.
 */
export async function installCloudAuthDeepLink(): Promise<() => void> {
  if (isTauri() === false) return () => {};

  try {
    const { onOpenUrl, getCurrent } =
      await import("@tauri-apps/plugin-deep-link");

    const apply = (urls: string[]): void => {
      let saved = false;
      for (const url of urls) {
        if (parseAuthCallbackUrl(url) !== null) saved = true;
      }
      if (saved) notifyCloudAuth();
    };

    const existing = await getCurrent();
    if (existing !== null && existing.length > 0) apply(existing);

    return await onOpenUrl(apply);
  } catch (error) {
    console.warn("Deep link plugin unavailable", error);
    return () => {};
  }
}
